import React from 'react';
import styled from 'styled-components';

// Definindo o tipo para as props do componente BarraSubAbas
interface SubAbasProps {
  children?: React.ReactNode;
}

const ContainerSubAbas = styled.div`
  display: grid;
  grid-template-columns: 3% 97%;
  position: sticky;
`;

// Ajustando o componente para receber e mapear as SubAbas
const SubAbas: React.FC<SubAbasProps> = ({ children }) => {
  return <ContainerSubAbas>{children}</ContainerSubAbas>;
};

export default SubAbas;
